import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, useReactFlow } from 'reactflow';
import { X } from 'lucide-react';

/**
 * Smooth-step edge with an X button at the midpoint to delete the connection.
 * The X is always visible but half-opacity; becomes fully opaque on hover / selection.
 */
export default function DeletableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
  label,
}) {
  const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
  });

  const onDelete = (e) => {
    e.stopPropagation();
    setEdges((edges) => edges.filter((ed) => ed.id !== id));
  };

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -140%) translate(${labelX}px, ${labelY}px)`,
              background: '#1f2937',
              color: '#e5e7eb',
              padding: '2px 6px',
              borderRadius: 4,
              fontSize: 11,
              border: '1px solid #374151',
              pointerEvents: 'none',
            }}
            className="nodrag nopan"
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
      <EdgeLabelRenderer>
        <button
          type="button"
          onClick={onDelete}
          data-testid={`delete-edge-${id}`}
          title="Remove connection"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            width: 18,
            height: 18,
            borderRadius: 9999,
            background: '#0f172a',
            border: '1px solid #ef4444',
            color: '#ef4444',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            opacity: selected ? 1 : 0.55,
            transition: 'opacity 120ms ease',
            pointerEvents: 'all',
          }}
          className="nodrag nopan hover:!opacity-100 hover:!bg-red-500/20"
        >
          <X size={12} strokeWidth={2.5} />
        </button>
      </EdgeLabelRenderer>
    </>
  );
}
